export default {
  defaultObject (_) {
    return {
      id: null,
      name: '',
      code: ''
    }
  }
}